import * as d3 from 'd3'

export default {

  methods: {

    loadSvg(selection, data) {
      return d3.xml(data.url).then(source => {
        let svg_ = source.documentElement
        selection.node().append(svg_)
        svg_ = d3.select(svg_)
        .attr('id', data.id)
        .attr('x', data.x).attr('y', data.y).attr('width', data.width).attr('height', data.height)
        .attr('viewBox', null)
        return new Promise(resolve => {
          resolve(svg_)
        })
      })
    },
    

    removeSvg(selection, time, func, props) {
      try {
        selection.transition().duration(time).style('opacity', 0)
      } catch(e) {
        // console.log(e)
      }

      setTimeout(() => {
        if (selection) {
          selection.remove()
          selection = null
        }
        func(props)
      }, time) 
    },


    gmx_groupBox(selection, props) {
      if(!props.sWidth) props.sWidth = .5

      let groupBox_ = selection
      .append('g')
      .attr('transform', `translate(${props.x}, ${props.y})`)

      groupBox_
      .append('rect')
      .attr('rx', 3).attr('ry', 3)
      .attr('width', props.width).attr('height', props.height)
      .attr('fill', '#fff').attr('stroke', '#dadada').attr('stroke-width', props.sWidth)

      groupBox_
      .append('rect')
      .attr('transform', `translate(10, -5)`)
      .attr('width', props.labelWidth).attr('height', 10).attr('fill', '#fff')

      groupBox_
      .append('text')
      .attr('transform', `translate(12, ${1 + 11*0.35})`)
      .style('font-size', 11).attr('text-anchor', 'start')
      .text(props.label)

      return groupBox_
    },

    
    gmx_Line(selection, x1, x2, y1, y2, stroke, sWidth, opacity=1) {
      selection
      .append('line')
      .attr('x1', x1).attr('x2', x2)
      .attr('y1', y1).attr('y2', y2)
      .attr('stroke', stroke).attr('stroke-width', sWidth)
      .attr('opacity', opacity)
    },

    
    gmx_Text(selection, id, x, y, tSize, tColor, align, base, txt) {
      let diff = 0
      if (base == 'middle') diff = 0.26
      else if (base == 'central') diff = 0.35
      else if (base == 'hanging') diff = 0.75

      selection
      .append('text')
      .attr('id', id)
      .attr('x', x).attr('y', y + (tSize*diff))
      .attr('font-size', tSize).attr('text-anchor', align)
      .attr('fill', tColor)
      .text(txt)
    },


    gmx_ProgressBar(selection, x, y, value, tSize, tColor, bar) {
      if(!bar.shift) bar.shift = 50

      let lenPro = (bar.width/100) * value
      selection
      .append('rect')
      .attr('x', x).attr('y', y - (bar.height/2))
      .attr('rx', bar.rx ? bar.rx : 0)
      .attr('width', bar.width).attr('height', bar.height)
      .attr('fill', '#bcbcbc').attr('opacity', .2)

      selection
      .append('rect')
      .attr('x', x).attr('y', y- (bar.height/2))
      .attr('rx', bar.rx ? bar.rx : 0)
      .attr('width', lenPro).attr('height', bar.height)
      .attr('fill', bar.color).attr('opacity', bar.opacity)

      selection
      .append('text')
      .attr('x', value > bar.shift ? x + lenPro -2 : x + lenPro +2)
      .attr('y', y+3.5)
      .attr('font-size', tSize).attr('fill', tColor)
      .attr('text-anchor', value > bar.shift ? 'end' : 'start')
      .text(value+'%')
    },
    

    // Updated:  2025-07-01
    gmx_wrapText(d){
      let group = d3.select(d.parents)
      group
      .append('text')
      .attr('font-size', d.tSize).attr('fill', d.tColor)
      .attr('text-anchor', d.align)
      .text(d.text)
      .call(wrapText, d.wSize)

      function wrapText(text, wSize) {
        text.each(function() {
          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineHeight = d.lineHeight,
              y = text.attr('y'),
              tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y)
          
          word = words.pop()
          while (word) {
            line.push(word)
            tspan.text(line.join(' '))
            if (tspan.node().getComputedTextLength() > wSize) {
              line.pop()
              tspan.text(line.join(' '))
              line = [word]
              tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', lineHeight).text(word)
            }
            word = words.pop()
          }
        })
      }
    },


    

  }
}
